import React, { useContext, useEffect, useRef } from "react";
import { useConnectMetaMask } from "../../hooks/useConnectMetaMask";
import { AppContext } from "../../scripts/context";
import { GetLocalStorag } from "../../Helper/Helper";
/*  This Component used if connect wallet call the submitConnectMetaMask function | khaled Mofeed */
function Index({ connected, address, account }) {
  const submitConnectMetaMask = useConnectMetaMask({});
  const { isToken, TOKEN_User } = useContext(AppContext) || {};
  const hasRequestedSignature = useRef(false);
  const lastAddressRef = useRef(null);

  useEffect(() => {
    // Reset signature request flag if address changed (user switched wallet)
    if (address && address !== lastAddressRef.current) {
      hasRequestedSignature.current = false;
      lastAddressRef.current = address;
    }

    // Check if we already have a valid token
    // Priority: Check localStorage first (most reliable), then state
    const storedToken = GetLocalStorag("UserToken");
    // If token exists in localStorage, consider it valid (don't request signature again)
    // This prevents duplicate signature requests when navigating between pages
    const hasValidToken = Boolean(storedToken);

    // Only request signature if:
    // 1. Wallet is connected
    // 2. Address is available
    // 3. No valid token exists
    // 4. We haven't already requested signature for this address
    if (connected && address && !hasValidToken && !hasRequestedSignature.current) {
      hasRequestedSignature.current = true;
      submitConnectMetaMask();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connected, address, account, isToken, TOKEN_User]);

  return;
}

export default Index;
